import { type TurnstileConfig } from './types';

export const FORBIDDEN_STATUS_CODE = 403;
export const RATE_LIMITED_STATUS_CODE = 429;
export const CHALLENGE_HEADER_KEY = 'cf-mitigated';
export const CHALLENGE_HEADER_VALUE = 'challenge';

export const TURNSTILE_SCRIPT_URL =
  'https://challenges.cloudflare.com/turnstile/v0/api.js';
export const WIDGET_CONTAINER_ID = 'turnstile-widget-container';

export const DEFAULT_TURNSTILE_CONFIG: TurnstileConfig = {
  siteKey: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY || '',
  mode: 'managed',
};

export const TURNSTILE_DUMMY_TOKEN = 'XXXX.DUMMY.TOKEN.XXXX';

export const TURNSTILE_EVENT_MODAL_TRIGGER = 'onTurnstileModalTrigger';
export const TURNSTILE_CHALLENGE_RESULT = 'onTurnstileChallengeResult';
